import { Chip, Paper, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';

import {
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';
import {
  formatDateTime,
  formatInstallments,
  formatInteger,
} from '../../utils/puntajeFormatters';
import TableStateRow from '../common/TableStateRow';

const RankingTable = ({
  title,
  rows,
  isLoading,
  pagination,
  onOpenDebtDetail,
  debtDetailLoadingContractUuid,
}) => (
  <Paper
    sx={{ p: 2.5, borderRadius: 0, borderTop: '1px solid', borderColor: 'divider' }}
  >
    <Typography variant="h6">{title}</Typography>
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell>#</HeadTableCell>
            <HeadTableCell>Contrato</HeadTableCell>
            <HeadTableCell>Suscriptor(es)</HeadTableCell>
            <HeadTableCell>Puntaje</HeadTableCell>
            <HeadTableCell>Cobros puntaje</HeadTableCell>
            <HeadTableCell>Ultimo cobro</HeadTableCell>
            <HeadTableCell>Mora</HeadTableCell>
            <HeadTableCell>Elegible</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows.length ? (
            <TableStateRow colSpan={8} loading={isLoading} emptyMessage="No hay contratos para mostrar." />
          ) : (
            rows.map((row) => (
              <TableRow key={row.uuid_contract} hover>
                <RowTableCell>{row.position || '-'}</RowTableCell>
                <RowTableCell>{row.contract_number}</RowTableCell>
                <RowTableCell>{(row.subscriber_names || []).join(', ') || '-'}</RowTableCell>
                <RowTableCell>{formatInstallments(row.score_installments)}</RowTableCell>
                <RowTableCell>{formatInteger(row.paid_score_coupons)}</RowTableCell>
                <RowTableCell>{formatDateTime(row.last_score_payment_date)}</RowTableCell>
                <RowTableCell>
                  <Chip
                    label={
                      debtDetailLoadingContractUuid === row.uuid_contract
                        ? 'Cargando...'
                        : row.is_morose
                          ? `Moroso (${row.overdue_coupon_count})`
                          : 'Sin mora'
                    }
                    color={row.is_morose ? 'error' : 'success'}
                    size="small"
                    variant="outlined"
                    clickable={Boolean(row.is_morose && onOpenDebtDetail)}
                    onClick={
                      row.is_morose && onOpenDebtDetail
                        ? () => onOpenDebtDetail(row)
                        : undefined
                    }
                    disabled={debtDetailLoadingContractUuid === row.uuid_contract}
                    sx={
                      row.is_morose && onOpenDebtDetail
                        ? { cursor: 'pointer' }
                        : undefined
                    }
                  />
                </RowTableCell>
                <RowTableCell>
                  <Chip
                    label={row.is_award_eligible ? 'Si' : 'No'}
                    color={row.is_award_eligible ? 'success' : 'default'}
                    size="small"
                    variant="outlined"
                  />
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
    {!!pagination?.totalCount && (
      <PaginationTable
        page={pagination.page}
        totalPages={pagination.totalPages}
        totalCount={pagination.totalCount}
        rowsPerPage={pagination.rowsPerPage}
        onPageChange={pagination.handlePageChange}
        onRowsPerPageChange={pagination.handleRowsPerPageChange}
      />
    )}
  </Paper>
);

export default RankingTable;
